<template>
  <v-dialog v-model="dlg" max-width="300px" persistent style="margin: auto 4px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ title || 'Are you sure?' }}</span>
      </v-card-title>
      <v-card-text>
        <template v-if="text">
          <div v-for="(txt, idx) in text.split('\n')" :key="idx" class="my-1 min-height">
            {{ txt }}
          </div>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn outlined color="primary" @click="confirmed(false)">{{ noLabel || 'Cancel' }}</v-btn>
        <v-btn color="primary" @click="confirmed(true)">{{ yesLabel || 'Confirm' }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['title', 'text', 'yesLabel', 'noLabel', 'dlg'],
  methods: {
    confirmed(val) {
      this.$emit('confirmed', val);
    },
  },
};
</script>

<style scoped>
  .min-height {
    min-height: 1em;
  }
</style>
